import HeyEdLoader from '@/theme/loader/HeyEdLoader';
import { ROUTES } from '@/utils/routerRoutes';
import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

const MainTheme = lazy(() => import('@/theme/mainTheme/MainTheme'));
const Dashboard = lazy(() => import('@/pages/dashboard/Dashboard'));

const Routes = () => {
  const routes = useRoutes([
    {
      path: '/',
      element: <MainTheme />,
      children: [
        { element: <Navigate to={ROUTES.MIGRATION} />, index: true },
        { path: ROUTES.MIGRATION, element: <Dashboard /> },
      ],
    },
    { path: '*', element: <Navigate to="/" /> },
  ]);

  return <Suspense fallback={<HeyEdLoader />}>{routes}</Suspense>;
};

export default Routes;
